<script setup lang="ts">
import { ref } from 'vue'

defineProps<{
  disabled?: boolean
}>()

const emit = defineEmits<{
  choose: [choice: string, comment: string]
}>()

const comment = ref('')

const options = [
  { value: 'a_better', label: 'A 更好', icon: 'A' },
  { value: 'b_better', label: 'B 更好', icon: 'B' },
  { value: 'both_good', label: '都不错', icon: '✓' },
  { value: 'both_bad', label: '都不行', icon: '×' },
]

function choose(choice: string) {
  emit('choose', choice, comment.value.trim())
}
</script>

<template>
  <section class="evaluation-panel">
    <div>
      <p class="eyebrow">评价</p>
      <h3>请你对本轮的模型输出做出评价：</h3>
    </div>
    <div class="evaluation-actions">
      <button
        v-for="option in options"
        :key="option.value"
        type="button"
        :disabled="disabled"
        @click="choose(option.value)"
      >
        <span>{{ option.icon }}</span>{{ option.label }}
      </button>
    </div>
    <label class="evaluation-comment">
      <span>你的评价 <small>（选填）</small></span>
      <textarea
        v-model="comment"
        rows="2"
        maxlength="2000"
        :disabled="disabled"
        placeholder="可以补充你选择这一评价的原因，不填写也可以继续"
      ></textarea>
    </label>
  </section>
</template>
